import {cDisplay} from '../creator/cDisplay'
import { cContainer } from '../creator/cGameObjects/cContainer';
import {cScene} from '../creator/cScene'


export class parallaxDisplay extends cDisplay {

  private levelContainers: cContainer[]
  private cS: cScene | null


  init(){
    super.init()
    this.cS = this.scene as any
    this.name = "parallax";
    console.log('INIT PARALLAX');
    (this.scene as cScene).ev.addListener('action',(a,b,c)=>{

    });

    (this.scene as cScene).ev.addListener('options',(a,b,c)=>{
      console.log('new options', this.cS.customeOptions)
      this.applyOffset()
    })

  }

  buildScene(){    
    super.buildScene();
    this.levelContainers = [
      this.getByName('level_0'),
      this.getByName('level_1'),
      this.getByName('level_2'),
    ]
    this.applyOffset()
    console.log('PARA', this.cS.customeOptions)

  }


  private applyOffset(){
    if (this.cS.customeOptions && this.cS.customeOptions.offset){
      this.animateToOffset(this.cS.customeOptions.offset)
    }else{
      this.animateToOffset(0)
    }
  }


  public getByName(st:string){
    console.log('XXX',st)

    if (st.indexOf(':') != -1){
      var [lev,tg] = st.split(':');
      var levRef = super.getByName(lev);
      if (levRef){
        console.log('DISPLA____',st,levRef)
        return levRef.getByName(tg);
      }
      return null;
  
    }else{
      return super.getByName(st)
    }
  }

  private animateToOffset( offset ){

    if ( !this.cS.sceneData.options.offsets ) console.error('Parallax Scene - but missing [offsets] in options')

    var offsets: number[] = String(this.cS.sceneData.options.offsets).split(',').map(e=>Number(e));
    var ofs = offsets[offset]
    var mp = 0.2 + ((1 / this.levelContainers.length) * 0.8)
    var $this = this;

    console.log('new ofs ..', ofs, offsets, this.cS.sceneData.options)

    $this.cS.triggerSceneEvent('start_offset_'+offset)

    this.levelContainers.forEach( (cC,i)=>{
      if (cC){
        console.log(cC)
        this.scene.tweens.add({
          targets: cC,
          delay:800,
          //x: -(ofs) * (mp * (i+1))
          x: -(ofs) * ((i+1) * 0.7),
          onComplete:()=>{
            if (i==0){              
              $this.cS.triggerSceneEvent('offset_'+offset)
            }          
          }

        })  
      }
    });
  }

}


